webpackJsonp([278999228825771],{

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(130);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(92);
	var each = __webpack_require__(44).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(90);
	var Util = __webpack_require__(44);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),

/***/ 92:
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(91);
	module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(115);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(35);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    // init: function hook that gets called right before InnerSlider mounts
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow should react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	exports.default = defaultProps;

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(112);

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    scrolling: false,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    swiping: false,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(111);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(35);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(109);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(48);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(89);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(113);
	
	var _dots = __webpack_require__(108);
	
	var _arrows = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  displayName: 'InnerSlider',
	
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null, // wraps the track
	  track: null, // component that rolls out like a film
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    // number of slides shown in the active frame
	    var slidesToShow = this.props.slidesToShow;
	    var childrenLen = _react2.default.Children.count(this.props.children);
	    var currentSlide = this.state.currentSlide;
	    for (var i = 0; i < childrenLen; i++) {
	      // if currentSlide is the lastSlide of current frame and 
	      // rest of the active slides are on the left of currentSlide
	      // then the following might cause a problem
	      if (i >= currentSlide && i < currentSlide + slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	    if (this.props.centerMode === true) {
	      // add slides to show on the left in case of centerMode with lazyLoad
	      var additionalCount = Math.floor(slidesToShow / 2);
	      if (parseInt(this.props.centerPadding) > 0) {
	        additionalCount += 1;
	      }
	      var additionalNum = currentSlide;
	      while (additionalCount--) {
	        lazyLoadedList.push((--additionalNum + childrenLen) % childrenLen);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.props.lazyLoad && this.props.centerMode) {
	      var childrenLen = _react2.default.Children.count(this.props.children);
	      var additionalCount = Math.floor(this.props.slidesToShow / 2);
	      if (parseInt(this.props.centerPadding) > 0) additionalCount++;
	      var leftMostSlide = (this.state.currentSlide - additionalCount + childrenLen) % childrenLen;
	      var rightMostSlide = (this.state.currentSlide + additionalCount) % childrenLen;
	      if (!this.state.lazyLoadedList.includes(leftMostSlide)) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList + [leftMostSlide]
	        });
	      }
	      if (!this.state.lazyLoadedList.includes(rightMostSlide)) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList + [rightMostSlide]
	        });
	      }
	    }
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    slide = Number(slide);
	    !isNaN(slide) && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(50);
	
	var _helpers = __webpack_require__(35);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = Number(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.scrolling) {
	      return;
	    }
	    if (this.state.animating) {
	      e.preventDefault();
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	    if (!this.props.verticalSwiping && !this.state.swiping && verticalSwipeLength > 4) {
	      this.setState({
	        scrolling: true
	      });
	      return;
	    }
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = verticalSwipeLength;
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      if (!this.props.rtl) {
	        swipeLeft = curLeft + touchSwipeLength * positionOffset;
	      } else {
	        swipeLeft = curLeft - touchSwipeLength * positionOffset;
	      }
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      this.setState({
	        swiping: true
	      });
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var currentIndex = this.props.rtl === true ? this.state.slideCount - this.state.currentSlide : this.state.currentSlide;
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    var wasScrolling = this.state.scrolling;
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      scrolling: false,
	      swiping: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    if (wasScrolling) {
	      return;
	    }
	
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(50);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  // supposed to start autoplay of slides
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	      // this reference isn't lost due to mixin
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (!props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem && (elem.getBoundingClientRect().width || elem.offsetWidth) || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem && (elem.getBoundingClientRect().height || elem.offsetHeight) || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        var elem = slickList.querySelector(selector) || {};
	        slickList.style.height = (elem.offsetHeight || 0) + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      if (targetLeft === currentLeft) {
	        targetSlide = currentSlide;
	      }
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return 'left';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return 'right';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	exports.getPreClones = getPreClones;
	exports.getPostClones = getPostClones;
	exports.getTotalSlides = getTotalSlides;
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// checks if spec is the superset of keys in keysArray, i.e., spec contains all the keys from keysArray
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow; // this should probably be getTotalSlides
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	    trackWidth += spec.slideWidth / 2; // this is a temporary hack so that track div doesn't create new row for slight overflow
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	  if (spec.fade) {
	    style = {
	      opacity: 1
	    };
	  }
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var lastSlide = _reactDom2.default.findDOMNode(trackRef).children[slideCount - 1];
	    var max = -lastSlide.offsetLeft + listWidth - lastSlide.offsetWidth;
	    if (slideCount <= slidesToShow || infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(trackRef).childNodes[slideIndex];
	    } else {
	      targetSlideIndex = slideIndex + slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      if (infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(trackRef).children[slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(trackRef).children[slideIndex + slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	    if (spec.infinite === false && targetLeft < max) {
	      targetLeft = max;
	    }
	  }
	
	  return targetLeft;
	};
	
	function getPreClones(spec) {
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	}
	
	function getPostClones(spec) {
	  return spec.slideCount;
	}
	
	function getTotalSlides(spec) {
	  return getPreClones(spec) + spec.slideCount + getPostClones(spec);
	}

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(110);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(94);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(48);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(78);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(93);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    // javascript handler for  css media query
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      // sort them in increasing order of their numerical value
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        // media query for each breakpoint
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        // when not using server side rendering
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      // convert javascript object to media query string
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.slickPause = function slickPause() {
	    this.innerSlider.pause();
	  };
	
	  Slider.prototype.slickPlay = function slickPlay() {
	    this.innerSlider.autoPlay();
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      // never executes in the first render
	      // so defaultProps should be already there in this.props
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, _defaultProps2.default, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    // force scrolling by one if centerMode is on
	    if (settings.centerMode) {
	      if (settings.slidesToScroll > 1 && ("production") !== 'production') {
	        console.warn('slidesToScroll should be equal to 1 in centerMode, you are using ' + settings.slidesToScroll);
	      }
	      settings.slidesToScroll = 1;
	    }
	    // force showing one slide and scrolling by one if the fade mode is on
	    if (settings.fade) {
	      if (settings.slidesToShow > 1 && ("production") !== 'production') {
	        console.warn('slidesToShow should be equal to 1 when fade is true, you\'re using ' + settings.slidesToShow);
	      }
	      if (settings.slidesToScroll > 1 && ("production") !== 'production') {
	        console.warn('slidesToScroll should be equal to 1 when fade is true, you\'re using ' + settings.slidesToScroll);
	      }
	      settings.slidesToShow = 1;
	      settings.slidesToScroll = 1;
	    }
	
	    // makes sure that children is an array, even when there is only 1 child
	    var children = _react2.default.Children.toArray(this.props.children);
	
	    // Children may contain false or null, so we should filter them
	    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	    children = children.filter(function (child) {
	      if (typeof child === 'string') {
	        return !!child.trim();
	      }
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className + ' unslicked' },
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(25);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  // if spec has currentSlideIndex, we can also apply slickCurrent class according to that (https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L2300-L2302)
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    // if we're going right to left, index is reversed
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    // index of the slide
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0; // concern: not sure if this should be correct (https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L2328-L2346)
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    // concern: following can be incorrect in case where currentSlide is lastSlide in frame and rest of the slides to show have index smaller than currentSlideIndex
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slideClass = child.props.className || '';
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    // push a cloned element of the desired slide
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: index }, spec)), slideClass),
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= spec.slidesToShow + (spec.centerMode ? 1 : 0) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    // var slides = renderSlides.call(this, this.props);
	    var slides = renderSlides(this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),

/***/ 834:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/affBG.9c812a98.jpg";

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/affSpice.4a2e6151.png";

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/contactShrimp.c5eef2f7.png";

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/homeAffiliations.4bf30dc9.png";

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAAA8AAD/4QMxaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzEzOCA3OS4xNTk4MjQsIDIwMTYvMDkvMTQtMDE6MDk6MDEgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE3IChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkMyNTM3QkZEMDJGRTExRTg4NDZDRTc0OEY5NjRFN0EyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkMyNTM3QkZFMDJGRTExRTg4NDZDRTc0OEY5NjRFN0EyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QzI1MzdCRkIwMkZFMTFFODg0NkNFNzQ4Rjk2NEU3QTIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QzI1MzdCRkMwMkZFMTFFODg0NkNFNzQ4Rjk2NEU3QTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7/7gAOQWRvYmUAZMAAAAAB/9sAhAAGBAQEBQQGBQUGCQYFBgkLCAYGCAsMCgoLCgoMEAwMDAwMDBAMDg8QDw4MExMUFBMTHBsbGxwfHx8fHx8fHx8fAQcHBw0MDRgQEBgaFREVGh8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx//wAARCAA/ABwDAREAAhEBAxEB/8QAWwABAQEBAAAAAAAAAAAAAAAAAAEEBwEBAAAAAAAAAAAAAAAAAAAAABABAQEAAQIGAwAAAAAAAAAAAQIAESFBMVFxQmIEQ1MFEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwDrGBgYGBgYGBgYAK8HVcFqaimaGal4qXoidnBMDBvA/nwVXX71HMT+ofc/N7eXrgwKqq8r4uBgYN8p/Qginj70nEU/lD2vzO3n64MCIonCeJgYGAKPJ44LVVdNUtVTzVPVV7uCYGBgYGBgYGBg/9k="

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAAA8AAD/4QMxaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjYtYzEzOCA3OS4xNTk4MjQsIDIwMTYvMDkvMTQtMDE6MDk6MDEgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE3IChNYWNpbnRvc2gpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkMyNTM3QkY5MDJGRTExRTg4NDZDRTc0OEY5NjRFN0EyIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkMyNTM3QkZBMDJGRTExRTg4NDZDRTc0OEY5NjRFN0EyIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QzI1MzdCRjcwMkZFMTFFODg0NkNFNzQ4Rjk2NEU3QTIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QzI1MzdCRjgwMkZFMTFFODg0NkNFNzQ4Rjk2NEU3QTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7/7gAOQWRvYmUAZMAAAAAB/9sAhAAGBAQEBQQGBQUGCQYFBgkLCAYGCAsMCgoLCgoMEAwMDAwMDBAMDg8QDw4MExMUFBMTHBsbGxwfHx8fHx8fHx8fAQcHBw0MDRgQEBgaFREVGh8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx//wAARCAA/ABwDAREAAhEBAxEB/8QAXAABAQEBAQAAAAAAAAAAAAAAAAEDBAcBAQAAAAAAAAAAAAAAAAAAAAAQAAICAQMEAwAAAAAAAAAAAAABAgMSESEEMUFRE4HBMxEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A9YAAAAAAAAAALhPBTxeDbSlptqt2tfkCAAAHRxOUqsqrY+zjWfpX326Sj4kgJyuK6JRcZeymxZU2rpJfTXdAYAAOjicVW5W2y9fGr/Szvv0jHzJgTlcp3yiox9dNaxqqXSK+2+7AwAAXOeChk8E21HXbV7N6fAEAAAAAAAAAAAH/2Q=="

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ropeHome.1f21df26.png";

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    h1, p {\n      text-align: left;\n    }\n    \n    display: grid;\n    grid-row-gap: 16px;\n    \n    @media(min-width: 992px){\n      grid-row-gap: 34px;\n    }\n    \n    @media(min-width: 1680px){\n      grid-row-gap: 68px;\n    }\n    \n    order: 2;\n'], ['\n    h1, p {\n      text-align: left;\n    }\n    \n    display: grid;\n    grid-row-gap: 16px;\n    \n    @media(min-width: 992px){\n      grid-row-gap: 34px;\n    }\n    \n    @media(min-width: 1680px){\n      grid-row-gap: 68px;\n    }\n    \n    order: 2;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-row-gap: 8px;\n  \n  @media(min-width: 992px) {\n    grid-row-gap: 24px;\n  }\n'], ['\n  display: grid;\n  grid-row-gap: 8px;\n  \n  @media(min-width: 992px) {\n    grid-row-gap: 24px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    color: #004a87;\n    font-family: Cabin-Bold, sans-serif;\n'], ['\n    color: #004a87;\n    font-family: Cabin-Bold, sans-serif;\n']);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Kit = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var DescriptionContainer = _styledComponents2.default.div(_templateObject2);
	
	var MissionContainer = DescriptionContainer.extend(_templateObject3);
	
	var MissionTitle = _Kit.P1.extend(_templateObject4);
	
	var AffiliateText = function AffiliateText(props) {
	  var _props$affiliate = props.affiliate,
	      name = _props$affiliate.name,
	      description = _props$affiliate.description,
	      acronym = _props$affiliate.acronym,
	      mission_text = _props$affiliate.mission_text;
	
	  return React.createElement(
	    Container,
	    null,
	    React.createElement(
	      DescriptionContainer,
	      null,
	      React.createElement(
	        _Kit.CardTitle,
	        null,
	        name
	      ),
	      React.createElement(_Kit.P2, {
	        dangerouslySetInnerHTML: { __html: description }
	      })
	    ),
	    React.createElement(
	      MissionContainer,
	      null,
	      React.createElement(
	        MissionTitle,
	        null,
	        acronym,
	        '\'s Mission'
	      ),
	      React.createElement(_Kit.P2, {
	        dangerouslySetInnerHTML: { __html: mission_text }
	      })
	    )
	  );
	};
	
	exports.default = AffiliateText;
	module.exports = exports['default'];

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n  \n  margin-bottom: -32px;\n  @media(min-width: 768px) {\n      padding-bottom: 0;  \n      margin-bottom: -100px;\n   }\n  \n  @media(min-width: 992px) {\n      padding-bottom: 0;  \n  }\n  \n  @media(min-width: 1200px) {\n      padding-bottom: 0;  \n  }\n  \n  @media(min-width: 1680px) {\n      padding-bottom: 0;  \n  }\n'], ['\n  position: relative;\n  \n  margin-bottom: -32px;\n  @media(min-width: 768px) {\n      padding-bottom: 0;  \n      margin-bottom: -100px;\n   }\n  \n  @media(min-width: 992px) {\n      padding-bottom: 0;  \n  }\n  \n  @media(min-width: 1200px) {\n      padding-bottom: 0;  \n  }\n  \n  @media(min-width: 1680px) {\n      padding-bottom: 0;  \n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose([' \n  position: absolute;\n  left: 0;\n  z-index: 0;\n  display: none;\n  \n  @media(min-width: 992px) {\n    display: block;\n    height: 20vw;\n  }\n'], [' \n  position: absolute;\n  left: 0;\n  z-index: 0;\n  display: none;\n  \n  @media(min-width: 992px) {\n    display: block;\n    height: 20vw;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  right: 0;\n  z-index: 0;\n  display: none;\n  \n  @media(min-width: 992px) {\n    display: block;\n    height: 20vw;\n  }\n'], ['\n  position: absolute;\n  right: 0;\n  z-index: 0;\n  display: none;\n  \n  @media(min-width: 992px) {\n    display: block;\n    height: 20vw;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  z-index: 1;\n  justify-content: center;\n  flex-wrap: wrap;\n  display: none;\n  \n  @media(min-width: 992px) {\n    display: flex;\n  }\n'], ['\n  z-index: 1;\n  justify-content: center;\n  flex-wrap: wrap;\n  display: none;\n  \n  @media(min-width: 992px) {\n    display: flex;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n   img {\n      width: auto;\n    }\n  \n  @media(min-width: 992px) {\n    flex-basis: 33%;\n    display: flex;\n    justify-content: center;\n    margin-bottom: 120px;\n  }\n  \n  @media(min-width: 1200px) {\n    flex-basis: 25%;\n  }\n'], ['\n   img {\n      width: auto;\n    }\n  \n  @media(min-width: 992px) {\n    flex-basis: 33%;\n    display: flex;\n    justify-content: center;\n    margin-bottom: 120px;\n  }\n  \n  @media(min-width: 1200px) {\n    flex-basis: 25%;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  padding: 0 20px;\n  display: block;\n  \n  @media(min-width: 992px) {\n    display: none;\n  }\n  \n  a{\n    display: flex;\n    justify-content: center;\n  }\n  \n  img{\n      height: 64px !important;\n  }\n'], ['\n  padding: 0 20px;\n  display: block;\n  \n  @media(min-width: 992px) {\n    display: none;\n  }\n  \n  a{\n    display: flex;\n    justify-content: center;\n  }\n  \n  img{\n      height: 64px !important;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _affSpice = __webpack_require__(75);
	
	var _affSpice2 = _interopRequireDefault(_affSpice);
	
	var _contactShrimp = __webpack_require__(224);
	
	var _contactShrimp2 = _interopRequireDefault(_contactShrimp);
	
	var _Container = __webpack_require__(10);
	
	var _Affiliations = __webpack_require__(77);
	
	var _reactSlick = __webpack_require__(49);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledBodyContainer = _Container.BodyContainer.extend(_templateObject);
	
	var SpiceImg = _styledComponents2.default.img(_templateObject2);
	
	var ShrimpImg = _styledComponents2.default.img(_templateObject3);
	
	var LogoContainer = _styledComponents2.default.div(_templateObject4);
	
	var SingleContainer = _styledComponents2.default.div(_templateObject5);
	
	var SliderContainer = _styledComponents2.default.div(_templateObject6);
	
	var AffiliationLogos = function AffiliationLogos(props) {
	  var logos = props.logos;
	
	  var settings = {
	    dots: false,
	    nextArrow: _react2.default.createElement(_Affiliations.RightArrow, null),
	    prevArrow: _react2.default.createElement(_Affiliations.LeftArrow, null),
	    infinite: true,
	    speed: 500,
	    slidesToShow: 2,
	    slidesToScroll: 1,
	    autoplay: false
	  };
	  return _react2.default.createElement(
	    StyledBodyContainer,
	    null,
	    _react2.default.createElement(SpiceImg, { src: _affSpice2.default }),
	    _react2.default.createElement(ShrimpImg, { src: _contactShrimp2.default }),
	    _react2.default.createElement(
	      SliderContainer,
	      null,
	      _react2.default.createElement(
	        _reactSlick2.default,
	        settings,
	        logos.map(function (i) {
	          var _i$node$acf = i.node.acf,
	              link = _i$node$acf.link,
	              _i$node$acf$logo = _i$node$acf.logo,
	              source_url = _i$node$acf$logo.source_url,
	              alt_text = _i$node$acf$logo.alt_text;
	
	          return _react2.default.createElement(
	            SingleContainer,
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://' + link, target: '_blank', title: '' + i.link },
	              _react2.default.createElement('img', {
	                src: source_url,
	                alt: alt_text
	              })
	            )
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      LogoContainer,
	      null,
	      logos.map(function (i) {
	        var _i$node$acf2 = i.node.acf,
	            link = _i$node$acf2.link,
	            _i$node$acf2$logo = _i$node$acf2.logo,
	            source_url = _i$node$acf2$logo.source_url,
	            alt_text = _i$node$acf2$logo.alt_text;
	
	        return _react2.default.createElement(
	          SingleContainer,
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://' + link, target: '_blank' },
	            _react2.default.createElement('img', {
	              src: source_url,
	              alt: alt_text
	            })
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = AffiliationLogos;
	module.exports = exports['default'];

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-row-gap: 16px;\n  \n  @media(min-width: 992px){\n      //padding: 60px 0 80px;\n      grid-row-gap: 24px;\n  }\n  @media(min-width: 1200px){\n        //padding: 90px 0 0;\n  }\n'], ['\n  display: grid;\n  grid-row-gap: 16px;\n  \n  @media(min-width: 992px){\n      //padding: 60px 0 80px;\n      grid-row-gap: 24px;\n  }\n  @media(min-width: 1200px){\n        //padding: 90px 0 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Kit = __webpack_require__(6);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Description = function Description(props) {
	  var header = props.header,
	      paragraph = props.paragraph;
	
	  return _react2.default.createElement(
	    _Container.BodyContainer,
	    null,
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(_Kit.SectionTitle, {
	        dangerouslySetInnerHTML: { __html: header }
	      }),
	      _react2.default.createElement(_Kit.P1, {
	        dangerouslySetInnerHTML: { __html: paragraph }
	      })
	    )
	  );
	};
	
	exports.default = Description;
	module.exports = exports['default'];

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 18px;\n  align-items: center;\n  \n  @media(min-width: 768px) {\n      grid-template-columns: 3fr 2fr;\n      grid-column-gap: 36px;\n  }\n'], ['\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 18px;\n  align-items: center;\n  \n  @media(min-width: 768px) {\n      grid-template-columns: 3fr 2fr;\n      grid-column-gap: 36px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: auto;\n  order: 1;\n  \n  @media(min-width: 768px) {\n      order: 2;\n  }\n'], ['\n  width: 100%;\n  height: auto;\n  order: 1;\n  \n  @media(min-width: 768px) {\n      order: 2;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  background-size: contain;\n  padding: 0 16px 32px;\n'], ['\n  background-size: contain;\n  padding: 0 16px 32px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AffiliateText = __webpack_require__(230);
	
	var _AffiliateText2 = _interopRequireDefault(_AffiliateText);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Img = _styledComponents2.default.img(_templateObject2);
	
	var StyledBodyContainer = _Container.BodyContainer.extend(_templateObject3);
	
	var FirstAffiliate = function FirstAffiliate(props) {
	  var _props$affiliate$node = props.affiliate.node.acf,
	      side_image = _props$affiliate$node.side_image,
	      source_url = _props$affiliate$node.logo.source_url,
	      affiliate = _objectWithoutProperties(_props$affiliate$node, ['side_image', 'logo']);
	
	  return _react2.default.createElement(
	    StyledBodyContainer,
	    { style: { background: 'url(' + source_url + ') no-repeat' } },
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(_AffiliateText2.default, { affiliate: affiliate }),
	      _react2.default.createElement(Img, {
	        src: side_image.source_url,
	        alt: side_image.alt_text
	      })
	    )
	  );
	};
	
	exports.default = FirstAffiliate;
	module.exports = exports['default'];

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 18px;\n  align-items: center;\n  \n  @media(min-width: 768px) {\n      grid-template-columns: 2fr 3fr;\n      grid-column-gap: 36px;\n  }\n'], ['\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 18px;\n  align-items: center;\n  \n  @media(min-width: 768px) {\n      grid-template-columns: 2fr 3fr;\n      grid-column-gap: 36px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: auto;\n  order: 1;\n'], ['\n  width: 100%;\n  height: auto;\n  order: 1;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  background-size: contain;\n  padding: 0 16px 32px;\n'], ['\n  background-size: contain;\n  padding: 0 16px 32px;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AffiliateText = __webpack_require__(230);
	
	var _AffiliateText2 = _interopRequireDefault(_AffiliateText);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Img = _styledComponents2.default.img(_templateObject2);
	
	var StyledBodyContainer = _Container.BodyContainer.extend(_templateObject3);
	
	var SecondAffiliate = function SecondAffiliate(props) {
	  var _props$affiliate$node = props.affiliate.node.acf,
	      side_image = _props$affiliate$node.side_image,
	      source_url = _props$affiliate$node.logo.source_url,
	      affiliate = _objectWithoutProperties(_props$affiliate$node, ['side_image', 'logo']);
	
	  return _react2.default.createElement(
	    StyledBodyContainer,
	    { style: { background: 'url(' + source_url + ') no-repeat right' } },
	    _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(Img, {
	        src: side_image.source_url,
	        alt: side_image.alt_text
	      }),
	      _react2.default.createElement(_AffiliateText2.default, {
	        affiliate: affiliate
	      })
	    )
	  );
	};
	
	exports.default = SecondAffiliate;
	module.exports = exports['default'];

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.RightArrow = exports.LeftArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 32px 0 50px;\n  display: grid;\n  grid-row-gap: 24px;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(2, auto);\n  z-index: 1;\n  \n  @media(min-width: 768px) {\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: auto;\n    grid-column-gap: 24px;\n    align-items: center;\n  }\n  \n  @media(min-width: 992px) {\n    padding-top: 50px;\n    padding-bottom: 50px;\n  }\n  \n  @media(min-width: 1200px) {\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n'], ['\n  padding: 32px 0 50px;\n  display: grid;\n  grid-row-gap: 24px;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(2, auto);\n  z-index: 1;\n  \n  @media(min-width: 768px) {\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: auto;\n    grid-column-gap: 24px;\n    align-items: center;\n  }\n  \n  @media(min-width: 992px) {\n    padding-top: 50px;\n    padding-bottom: 50px;\n  }\n  \n  @media(min-width: 1200px) {\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    display: block;\n    position: absolute;\n    width: 100%;\n    left: 0;\n    right: 0;\n    top: -2%;\n    z-index: 1;\n'], ['\n    display: block;\n    position: absolute;\n    width: 100%;\n    left: 0;\n    right: 0;\n    top: -2%;\n    z-index: 1;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: none;\n  \n  @media(min-width: 768px) {\n      display: block;\n      position: absolute;\n      left: 0;\n      top: 0;\n      height: 65%;\n  }\n  \n  @media(min-width: 1200px) {\n    height: 80%\n  }\n  \n  @media(min-width: 1680px) {\n    height: auto;\n  }\n'], ['\n  display: none;\n  \n  @media(min-width: 768px) {\n      display: block;\n      position: absolute;\n      left: 0;\n      top: 0;\n      height: 65%;\n  }\n  \n  @media(min-width: 1200px) {\n    height: 80%\n  }\n  \n  @media(min-width: 1680px) {\n    height: auto;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n'], ['\n  width: 100%;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  padding: 0 20px;\n  \n  @media(min-width: 992px) {\n    padding: 0;\n    \n    .slick-slider{\n        .slick-arrow{\n            display:none !important;\n        }\n        .slick-prev {\n          left: 0 !important;\n        }\n        .slick-next {\n          right: 0 !important;\n        }\n        &:hover{\n            .slick-arrow{\n                display:block !important;\n            }\n        }\n    }\n  }\n'], ['\n  padding: 0 20px;\n  \n  @media(min-width: 992px) {\n    padding: 0;\n    \n    .slick-slider{\n        .slick-arrow{\n            display:none !important;\n        }\n        .slick-prev {\n          left: 0 !important;\n        }\n        .slick-next {\n          right: 0 !important;\n        }\n        &:hover{\n            .slick-arrow{\n                display:block !important;\n            }\n        }\n    }\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n'], ['\n  display: flex;\n  justify-content: center;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n  height: 64px !important;\n  \n  @media(min-width: 768px) {\n    height: initial !important;\n  }\n   \n'], ['\n  cursor: pointer;\n  height: 64px !important;\n  \n  @media(min-width: 768px) {\n    height: initial !important;\n  }\n   \n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  background: transparent;\n'], ['\n  background: transparent;\n']);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _CardButton = __webpack_require__(60);
	
	var _CardButton2 = _interopRequireDefault(_CardButton);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _homeAffiliations = __webpack_require__(116);
	
	var _homeAffiliations2 = _interopRequireDefault(_homeAffiliations);
	
	var _affSpice = __webpack_require__(75);
	
	var _affSpice2 = _interopRequireDefault(_affSpice);
	
	var _ropeHome = __webpack_require__(119);
	
	var _ropeHome2 = _interopRequireDefault(_ropeHome);
	
	var _Container = __webpack_require__(10);
	
	var _reactSlick = __webpack_require__(49);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _nextArrow = __webpack_require__(118);
	
	var _nextArrow2 = _interopRequireDefault(_nextArrow);
	
	var _leftArrow = __webpack_require__(117);
	
	var _leftArrow2 = _interopRequireDefault(_leftArrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var InnerContainer = (0, _styledComponents2.default)(_Container.BodyContainer)(_templateObject);
	
	var Rope = _styledComponents2.default.img(_templateObject2);
	
	var SpiceBG = _styledComponents2.default.img(_templateObject3);
	
	var AffiliationImg = _styledComponents2.default.img(_templateObject4);
	
	var SliderContainer = _styledComponents2.default.div(_templateObject5);
	
	var CarouselContainer = _styledComponents2.default.div(_templateObject6);
	
	var CarouselImg = _styledComponents2.default.img(_templateObject7);
	
	var AffiliationsCard = (0, _styledComponents2.default)(_CardButton2.default)(_templateObject8);
	
	var LeftArrow = exports.LeftArrow = function LeftArrow(props) {
	    var className = props.className,
	        style = props.style,
	        onClick = props.onClick;
	
	    return React.createElement('img', {
	        className: className,
	        onClick: onClick,
	        style: _extends({}, style, { height: 'auto', zIndex: '10' }),
	        src: _leftArrow2.default,
	        alt: 'previous arrow' });
	};
	var RightArrow = exports.RightArrow = function RightArrow(props) {
	    var className = props.className,
	        style = props.style,
	        onClick = props.onClick;
	
	    return React.createElement('img', {
	        className: className,
	        onClick: onClick,
	        style: _extends({}, style, { height: 'auto', zIndex: '10' }),
	        src: _nextArrow2.default,
	        alt: 'next arrow' });
	};
	
	var Affiliations = function Affiliations(props) {
	    var settings = {
	        dots: false,
	        nextArrow: React.createElement(RightArrow, null),
	        prevArrow: React.createElement(LeftArrow, null),
	        infinite: true,
	        speed: 500,
	        slidesToShow: 5,
	        slidesToScroll: 1,
	        autoplay: false,
	        responsive: [{
	            breakpoint: 1680,
	            settings: {
	                slidesToShow: 3,
	                slidesToScroll: 1,
	                infinite: true
	            }
	        }, {
	            breakpoint: 992,
	            settings: {
	                slidesToShow: 2,
	                slidesToScroll: 1
	            }
	        }]
	    };
	    var _props$data = props.data,
	        header = _props$data.header,
	        paragraph = _props$data.paragraph,
	        affiliateData = props.affiliateData;
	
	    return React.createElement(
	        _Container.BodyContainer,
	        null,
	        React.createElement(Rope, { src: _ropeHome2.default, alt: 'rope' }),
	        React.createElement(SpiceBG, { src: _affSpice2.default, alt: 'spice' }),
	        React.createElement(
	            InnerContainer,
	            null,
	            React.createElement(AffiliationImg, { src: _homeAffiliations2.default, alt: 'H & N Group Seafood Supplier' }),
	            React.createElement(AffiliationsCard, {
	                header: header,
	                subtitle: paragraph,
	                buttonText: 'Discover',
	                link: '/affiliations',
	                title: 'H & N Group Affilates'
	            })
	        ),
	        React.createElement(
	            SliderContainer,
	            null,
	            React.createElement(
	                _reactSlick2.default,
	                settings,
	                affiliateData.map(function (i) {
	                    var _i$node$acf = i.node.acf,
	                        name = _i$node$acf.name,
	                        link = _i$node$acf.link,
	                        logo = _i$node$acf.logo;
	
	                    return React.createElement(
	                        'a',
	                        {
	                            key: name,
	                            href: 'https://' + link,
	                            target: '_blank'
	                        },
	                        React.createElement(
	                            CarouselContainer,
	                            null,
	                            React.createElement(CarouselImg, { src: logo.source_url, alt: logo.alt_text })
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	exports.default = Affiliations;

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  padding: 50px 20px 32px ;\n  background: #fff;\n  align-items: center;\n  justify-content: center;\n  \n  .content {\n    margin: 16px 0;\n  }\n  \n  @media(min-width: 768px) {\n    justify-items: left;\n    align-items: left;\n  \n    h1, p {\n      text-align: left;\n    }\n    \n    padding: 30px 32px;\n  }\n  \n  @media(min-width: 992px){\n    padding: 60px 60px 50px;\n    \n    .content {\n      margin: 32px 0;\n    }\n  }\n  \n  a {\n        text-decoration: none;\n        color: #004a87;\n        width: 100%;\n        max-width: 120px;\n        height: 30px;\n          \n       @media(min-width: 768px){\n         max-width: 190px;\n         height: 48px;\n      }\n  }\n  \n  p{\n    margin: 10px 0;\n    \n    @media(min-width: 768px){\n        margin: 16px 0;\n    }\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  padding: 50px 20px 32px ;\n  background: #fff;\n  align-items: center;\n  justify-content: center;\n  \n  .content {\n    margin: 16px 0;\n  }\n  \n  @media(min-width: 768px) {\n    justify-items: left;\n    align-items: left;\n  \n    h1, p {\n      text-align: left;\n    }\n    \n    padding: 30px 32px;\n  }\n  \n  @media(min-width: 992px){\n    padding: 60px 60px 50px;\n    \n    .content {\n      margin: 32px 0;\n    }\n  }\n  \n  a {\n        text-decoration: none;\n        color: #004a87;\n        width: 100%;\n        max-width: 120px;\n        height: 30px;\n          \n       @media(min-width: 768px){\n         max-width: 190px;\n         height: 48px;\n      }\n  }\n  \n  p{\n    margin: 10px 0;\n    \n    @media(min-width: 768px){\n        margin: 16px 0;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Kit = __webpack_require__(6);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var CardButton = function (_Component) {
	  _inherits(CardButton, _Component);
	
	  function CardButton() {
	    _classCallCheck(this, CardButton);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  CardButton.prototype.render = function render() {
	    var _props = this.props,
	        title = _props.title,
	        subtitle = _props.subtitle,
	        buttonText = _props.buttonText,
	        className = _props.className,
	        link = _props.link,
	        header = _props.header;
	
	    return _react2.default.createElement(
	      Container,
	      { className: className },
	      _react2.default.createElement(
	        _Kit.CardTitle,
	        null,
	        header
	      ),
	      _react2.default.createElement(_Kit.P2, {
	        dangerouslySetInnerHTML: { __html: subtitle }
	      }),
	      link ? _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: link, title: title },
	        ' ',
	        _react2.default.createElement(
	          _Kit.OutlineButton,
	          null,
	          buttonText
	        )
	      ) : _react2.default.createElement(
	        _Kit.OutlineButton,
	        null,
	        buttonText
	      )
	    );
	  };
	
	  return CardButton;
	}(_react.Component);
	
	;
	
	exports.default = CardButton;
	module.exports = exports['default'];

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.affiliationsQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(122);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _affBG = __webpack_require__(834);
	
	var _affBG2 = _interopRequireDefault(_affBG);
	
	var _Description = __webpack_require__(350);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	var _FirstAffiliate = __webpack_require__(351);
	
	var _FirstAffiliate2 = _interopRequireDefault(_FirstAffiliate);
	
	var _SecondAffiliate = __webpack_require__(352);
	
	var _SecondAffiliate2 = _interopRequireDefault(_SecondAffiliate);
	
	var _AffiliationLogos = __webpack_require__(349);
	
	var _AffiliationLogos2 = _interopRequireDefault(_AffiliationLogos);
	
	var _hngutils = __webpack_require__(59);
	
	var _hngutils2 = _interopRequireDefault(_hngutils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Affiliations = function (_Component) {
	    _inherits(Affiliations, _Component);
	
	    function Affiliations(props) {
	        _classCallCheck(this, Affiliations);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.props.data.affiliateData.edges.forEach(function (edge) {
	            _hngutils2.default.imageSrcToLocalFile(edge.node.acf.logo);
	            _hngutils2.default.imageSrcToLocalFile(edge.node.acf.side_image);
	        });
	
	        _this.props.data.logos.edges.forEach(function (edge) {
	            _hngutils2.default.imageSrcToLocalFile(edge.node.acf.logo);
	        });
	        return _this;
	    }
	
	    Affiliations.prototype.render = function render() {
	        var affiliateData = this.props.data.affiliateData.edges;
	        var affiliateLogos = this.props.data.logos.edges;
	        var _props$data$header$ed = this.props.data.header.edges[0].node,
	            content = _props$data$header$ed.content,
	            _props$data$header$ed2 = _props$data$header$ed.acf,
	            header = _props$data$header$ed2.header,
	            subheader = _props$data$header$ed2.subheader;
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Header2.default, {
	                title: header,
	                bg: _affBG2.default
	            }),
	            _react2.default.createElement(_Description2.default, {
	                header: subheader,
	                paragraph: content
	            }),
	            _react2.default.createElement(_FirstAffiliate2.default, { affiliate: affiliateData[0] }),
	            _react2.default.createElement(_SecondAffiliate2.default, { affiliate: affiliateData[1] }),
	            _react2.default.createElement(_AffiliationLogos2.default, { logos: affiliateLogos })
	        );
	    };
	
	    return Affiliations;
	}(_react.Component);
	
	;
	
	exports.default = Affiliations;
	
	// affiliate parent = 462
	
	var affiliationsQuery = exports.affiliationsQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-affiliations-js-b6b0f572ece505d6bc31.js